import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';

export interface ZoomInfoConnectPayload {
  code: string;
  redirectUri: string;
}

export function useConnectZoomInfo() {
  const queryClient = useQueryClient();

  return useMutation<Response<void>, CronoError, ZoomInfoConnectPayload>({
    mutationFn: (data) => {
      return client({
        url: ENDPOINTS.zoomInfo.oauth,
        config: {
          method: 'post',
          data,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([ENDPOINTS.enrichmentProvider.main]);
    },
    meta: {
      successMessage: 'ZoomInfo connected successfully',
      errorMessage: 'Error while connecting with ZoomInfo',
    },
  });
}
